import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-loader-spinner',
    templateUrl: './loader-spinner.component.html',
    styleUrl: './loader-spinner.component.css',
    standalone: false
})
export class LoaderSpinnerComponent {
  @Input()
  labelName: string = 'Searching';
}
